import { BatchConfig } from "@plugins/user-activity-track/types.ts";

export const AWS_CONFIG = {
  AWS_REGION: "ap-southeast-1",
  FIREHOSE: {
    STREAM: "user_activity_track_firehose", // Firehose stream name
  },
};

export const DEFAULT_CONFIG: BatchConfig = {
  batchDelay: 5000,
  //For multi record de-aggregation, you can not put more than 500 records even if the data blob length is less than 1000 KiB
  batchSize: 100,
};

export const PROVIDER_TYPE = "aws-firehose";

export const SCHEMA_VERSION = "1.0.0";

export const CONNECTION_EVENT_KEY = "connectionEvents";
